// shared/state-container/state-container.component.ts
import { Component, Input, Output, EventEmitter, ContentChild, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmptyStateComponent } from '../empty-state/empty-state.component';
import { LoadingStateComponent } from '../loading-state/loading-state.component';

export type ViewState = 'loading' | 'empty' | 'content' | 'error';

@Component({
  selector: 'app-state-container',
  standalone: true,
  imports: [CommonModule, LoadingStateComponent, EmptyStateComponent],
  template: `
    @if (state === 'loading') {
      <app-loading-state 
        [message]="loadingMessage" 
        [subMessage]="loadingSubMessage"
      ></app-loading-state>
    } 
    @else if (state === 'empty') {
      <app-empty-state
        [icon]="emptyIcon"
        [title]="emptyTitle"
        [message]="emptyMessage"
        [showAction]="showEmptyAction"
        [actionLabel]="emptyActionLabel"
        [actionIcon]="emptyActionIcon"
        [actionOutlined]="emptyActionOutlined"
        [showClearFilters]="showClearFilters"
        (action)="emptyAction.emit()"
        (clearFilters)="clearFilters.emit()"
      ></app-empty-state>
    } 
    @else if (state === 'error') {
      <app-empty-state
        icon="pi-exclamation-triangle"
        title="Error"
        [message]="errorMessage || 'Something went wrong. Please try again.'"
        [showAction]="true"
        actionLabel="Retry"
        actionIcon="pi-refresh"
        (action)="retry.emit()"
      ></app-empty-state>
    }
    @else {
      <ng-content></ng-content>
    }
  `
})
export class StateContainerComponent {
  @Input() state: ViewState = 'content';
  
  // Loading props
  @Input() loadingMessage: string = 'Loading...';
  @Input() loadingSubMessage?: string;
  
  // Empty props
  @Input() emptyIcon: string = 'pi-users';
  @Input() emptyTitle: string = 'No items found';
  @Input() emptyMessage: string = 'No items found';
  @Input() showEmptyAction: boolean = false;
  @Input() emptyActionLabel: string = 'Create New';
  @Input() emptyActionIcon: string = 'pi-plus';
  @Input() emptyActionOutlined: boolean = false;
  @Input() showClearFilters: boolean = false;
  
  // Error props
  @Input() errorMessage?: string;
  
  @Output() emptyAction = new EventEmitter<void>();
  @Output() clearFilters = new EventEmitter<void>();
  @Output() retry = new EventEmitter<void>();
}